/**
 * The two non-money formatters the affiliate screens share.
 *
 * Money does NOT live here: it goes through `lib/formatMoney.js#formatMoneyCode` with the
 * currency the server stated on the row, and there is no second implementation.
 */
import { dateLocale } from "../../i18n/dateLocale";

/** The placeholder for a value the server sent as `null` — punctuation, not prose. */
export const EMPTY = "—";

/**
 * An ISO-8601 instant as a date in the reader's locale, `EMPTY` when it is absent.
 * A referral that never activated carries `activatedAt: null` and `windowEndsAt: null`
 * TOGETHER, and rendering either as "Invalid Date" would read as a defect in the data.
 */
export const fmtDate = (iso, lang) => {
  if (!iso) return EMPTY;
  const ms = Date.parse(iso);
  return Number.isFinite(ms) ? new Date(ms).toLocaleDateString(dateLocale(lang)) : EMPTY;
};

/**
 * Basis points as a percentage, with no invented precision: 1000 -> "10", 1250 -> "12.5".
 * Same rule as `gateway/components/GatewayWallet.jsx#fmtBps` — a rate is not an amount and
 * is in no currency, so it has no business in a money formatter.
 */
export const fmtBps = (bps) => String(Math.round(Number(bps) / 10) / 10);

/** The inverse, for a form that lets an operator type a percentage: "12.5" -> 1250. */
export const pctToBps = (pct) => Math.round(Number(pct) * 100);
